<template>
  <SubPage />
</template>

<script setup>
import SubPage from "~/pages/[lang]/[cinema-slug]/[sub-page]/index.vue";
</script>
